/**
 * HelpTooltip — small (?) icon with a popover, matching the existing
 * SettingsToggle help affordance (Chakra Popover). Used by feed-setting sections.
 */
import { FC } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  IconButton,
} from "@chakra-ui/react";
import { IoIosHelpCircleOutline } from "react-icons/io";

interface HelpTooltipProps {
  title: string;
  content: string;
}

const HelpTooltip: FC<HelpTooltipProps> = ({ title, content }) => (
  <Popover placement="bottom">
    <PopoverTrigger>
      <IconButton
        aria-label={`Help: ${title}`}
        icon={<IoIosHelpCircleOutline size={18} />}
        size="xs"
        variant="ghost"
        color="var(--color-grey)"
        _hover={{ backgroundColor: "var(--color-grey-lightest)" }}
        _active={{ backgroundColor: "var(--color-grey-lightest)" }}
      />
    </PopoverTrigger>
    <PopoverContent maxW="280px" borderRadius="xl">
      <PopoverArrow />
      <PopoverCloseButton />
      <PopoverBody>
        <p>
          <strong>{title}</strong>
        </p>
        <p>{content}</p>
      </PopoverBody>
    </PopoverContent>
  </Popover>
);

export default HelpTooltip;
